<template>
  <div class="pc-list" ref="list">
    <NewsSearch @search="search" ref="reSearch" />
    <div class="pc-head">
      <div class="pc-head-handle">
        <div class="pc-head-btn">
          <button @click="deleteNewsInit">删除</button>
          <span></span>
          <button @click="addNews">添加</button>
          <span></span>
          <button @click="exportNews">导出数据</button>
          <span></span>
          <button @click="cleanNews">清除新闻</button>
        </div>
        <p>{{ "共 " + pagination_options.total + " 条" }}</p>
      </div>
    </div>
    <el-table
      class="pc-list-table"
      :data="newsList"
      @sort-change="changeSort"
      v-loading="loading"
    >
      <el-table-column width="90" fixed="left">
        <template slot="header" slot-scope="header">
          <el-checkbox v-model="isSelectAll" @change="selectAll"
            >已选{{ checked.length }}个</el-checkbox
          >
        </template>
        <template slot-scope="scope">
          <el-checkbox
            v-model="scope.row.isSelect"
            @change="
              singleCheck(
                scope.$index,
                scope.row.isSelect,
                scope.row.id,
                scope.row
              )
            "
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column
        prop="id"
        label="ID"
        sortable="custom"
        width="70"
        fixed="left"
      ></el-table-column>
      <el-table-column label="标题" width="150" prop="title" fixed="left">
      </el-table-column>
      <el-table-column label="封面图" width="70">
        <template slot-scope="scope">
          <div v-if="scope.row.cover_image" class="eltable-img">
            <img :src="scope.row.cover_image" />
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="news_type"
        label="类型"
        width="80"
      ></el-table-column>
      <el-table-column label="来源" width="120" prop="source">
      </el-table-column>

      <el-table-column label="状态" width="100" sortable="custom" prop="status">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            @change="changeStatus(scope.row)"
            active-color="#91CC75"
            inactive-color="#C7C7C7"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="create_time"
        sortable="custom"
        width="120"
      >
        <template slot-scope="scope">
          <div>{{ $dtime(scope.row.create_time).format("YYYY.MM.DD") }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="发布时间"
        prop="publish_time"
        sortable="custom"
        width="120"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.publish_time">
            {{ $dtime(scope.row.publish_time).format("YYYY.MM.DD") }}
          </div>
          <div v-else>未发布</div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" min-width="120">
        <template slot-scope="scope">
          <button
            class="btnViewDetail"
            @click="viewDetail(scope.row)"
            :class="scope.row.read_flag == 1 ? 'active' : ''"
          >
            查看详情
          </button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-if="newsList.length > 0"
      :pagination="pagination_options"
      @goPage="goPage"
    />
    <DeleteHint
      :dialogVisible="deleteDialogVisible"
      @cancel="closeDelete"
      @delete="deleteNews"
    />
  </div>
</template>

<script>
import NewsSearch from "./NewsSearch";
import DeleteHint from "../../../template/DeleteHint";
import Pagination from "../../../componentSet/Pagination";
import {
  newsSearch_Api,
  deleteNewsList_Api,
  updateNews_Api,
  cleanNews_Api,
  outputNews_Api,
} from "../../../../apis/news.api";
export default {
  components: {
    NewsSearch,
    DeleteHint,
    Pagination,
  },
  data() {
    return {
      loading: false,
      deleteDialogVisible: false,
      isActive: null,
      searchRules: {
        page: 1,
        page_size: 10,
        order: "-id",
      },
      pagination_options: {
        page:1,
        total: 0,
        take:10,
      },
      isSelectAll: false,
      newsList: [],
      checked: [],
    };
  },
  mounted() {
    this.getNewsListByRules(this.searchRules);
  },
  methods: {
    cleanNews() {
      cleanNews_Api().then(() => {
        this.$global.success(this, "清除90天以上失效新闻成功！", null);
        this.getNewsListByRules(this.searchRules);
      });
    },
    getNewsListByRules(data) {
      this.loading = true;
      newsSearch_Api(data)
        .then((res) => {
          this.$set(this.pagination_options, "total", res.count);
          // this.pagination_options.total = res.count;
          res.data.forEach((el) => {
            if (el.news_type == "Exploration") {
              el.cover_image =
                "http://58.33.91.82:12404/wupen-test/images/exploration_default.png";
            }
            el.isSelect = false;
            
            if (el.chinese_title) {
              el.title = el.chinese_title;
            } else if (el.english_title) {
              el.title = el.english_title;
            } else {
              el.title = "无标题";
            }
           
          });
          this.newsList = res.data;
          this.loading = false;
          this.$global.success(this, "获取成功", null);
        })
        .catch(() => {
          this.loading = false;
          this.$global.error(this, "获取失败！", null);
        });
    },
    changeSort(val) {
      if (val.order == "ascending") {
        this.searchRules.order = "+" + val.prop;
      }
      if (val.order == "descending") {
        this.searchRules.order = "-" + val.prop;
      }
      if (val.order == null) {
        this.searchRules.order = "-id";
      }
      this.searchRules.page = 1;
      let data = this.dealSearchRules(this.searchRules);
      this.getNewsListByRules(data);
      this.pagination_options.page = 1;
    },
    search(formData) {
      this.searchRules = { ...this.searchRules, page: 1, ...formData };
      let data = this.dealSearchRules(this.searchRules);
      console.log(this.searchRules, data);
      this.getNewsListByRules(data);
      this.pagination_options.page = 1;
    },
    dealSearchRules(formData) {
      let data = {};
      if (formData.page) {
        data.page = formData.page;
      }
      if (formData.page_size) {
        data.page_size = formData.page_size;
      }
      if (formData.order) {
        data.order = formData.order;
      }
      if (formData.title_keywords && formData.title_keywords[0]) {
        data.title_keywords = formData.title_keywords;
      }
      if (formData.news_type) {
        data.news_type = formData.news_type;
      }
      if (formData.tags_keywords && formData.tags_keywords.length > 0) {
        data.tags_keywords = [...formData.tags_keywords];
      }
      if (formData.id) {
        data.id = parseInt(formData.id);
      }
      if (formData.topic_id) {
        data.topic_id = parseInt(formData.topic_id);
      }
      if (formData.status) {
        data.status = parseInt(formData.status);
      }
      if (formData.publish_time) {
        data.publish_start_time = this.$dtime(formData.publish_time[0]).format(
          "YYYY-MM-DD"
        );
        data.publish_end_time = this.$dtime(formData.publish_time[1]).format(
          "YYYY-MM-DD"
        );
      }
      return data;
    },
    deleteNewsInit() {
      if (this.checked.length > 0) {
        this.deleteDialogVisible = true;
      } else {
        this.$global.error(this, "请先勾选要删除的项目！", null);
      }
    },
    addNews() {
      let route = this.$router.resolve({
        path: "/admin/newsdetail",
        query: { method: "add" },
      });
      window.open(route.href, "_blank");
    },
    exportNews() {
      if (this.checked.length > 0) {
        outputNews_Api({ news_id: this.checked }).then((res) => {
          this.$global.downloadFile(res, "newsList");
        });
      } else {
        this.$global.error(this, "请先勾选要删除的项目！", null);
      }
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
    viewDetail(item) {
      item.read_flag=1
      let route = this.$router.resolve({
        path: "/admin/newsdetail",
        query: { id: item.id,method:'update' },
      });
      window.open(route.href, "_blank");
    },
    // 全选按钮
    selectAll() {
      if (this.isSelectAll) {
        this.checked = [];
        this.newsList.forEach((item, i, arr) => {
          this.$set(item, "isSelect", true);
          this.checked.push(item.id);
        });
      } else {
        this.newsList.forEach((item, i, arr) => {
          item.isSelect = false;
          this.checked = [];
        });
      }
    },
    // 单选按钮
    singleCheck(index, isSelect, rowID, row) {
      if (isSelect == false) {
        this.isSelectAll = false;
        for (let i = 0; this.checked.length > i; i++) {
          if (this.checked[i] == rowID) {
            this.checked.splice(i, 1);
            return;
          }
        }
      } else {
        this.checked.push(rowID);
        if (this.checked.length == 10) {
          this.isSelectAll = true;
        }
      }
      console.log(this.checked);
    },
    changeStatus(row) {
      updateNews_Api({ news_id: row.id, status: row.status })
        .then(() => {
          console.log("修改状态成功！");
          this.$global.success(this, "修改状态成功！", null);
        })
        .catch((res) => {
          console.log("修改状态失败！");
        });
    },
    deleteNews() {
      let delete_ids = { news_id_list: this.checked };
      console.log("delete_ids:", delete_ids);
      deleteNewsList_Api(delete_ids)
        .then((res) => {
          console.log("批量删除成功！");
          this.checked = [];
          this.deleteDialogVisible = false;
          this.$global.success(this, "删除成功！");
          this.searchRules.page = 1;
          let data = this.dealSearchRules(this.searchRules);
          this.getNewsListByRules(data);
          this.pagination_options.page = 1;
        })
        .catch((err) => {
          console.log("批量删除失败！");
        });
    },
    goPage(pageNo) {
      this.pagination_options.page = pageNo;
      this.searchRules.page = pageNo;
      let data = this.dealSearchRules(this.searchRules);
      this.getNewsListByRules(data);
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-list {
  @include table-head;
  .active{
    color: $base-color;
    background: $timeBtn;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/news/components/NewsTable.vue